export default __webpack_public_path__ + "static/media/unequal-sa3.3d69824b.jpg";